"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isBrowser = _interopRequireDefault(require("../../_utils/isBrowser"));

var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  'height': '0',
  'visibility': 'hidden',
  'overflow': 'hidden',
  'position': 'absolute',
  'z-index': '-1000',
  'top': '0',
  'right': '0'
};
var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

var _getNodeSizingProps = function _getNodeSizingProps(node) {
  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
    return Object.assign(obj, (0, _defineProperty2.default)({}, name, style.getPropertyValue(name)));
  }, {});
  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
  return {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };
};

var hiddenTextarea;

var computeTextareaHeights = function computeTextareaHeights(node) {
  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!_isBrowser.default || !document.body) {
    return null;
  }

  var _document = document,
      body = _document.body;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    body.appendChild(hiddenTextarea);
  }

  var wrap = node.getAttribute('wrap');

  if (wrap) {
    hiddenTextarea.setAttribute('wrap', wrap);
  } else {
    hiddenTextarea.removeAttribute('wrap');
  }

  var nodeSizingProps = _getNodeSizingProps(node);

  if (nodeSizingProps === null) {
    return null;
  }

  var paddingSize = nodeSizingProps.paddingSize,
      borderSize = nodeSizingProps.borderSize,
      boxSizing = nodeSizingProps.boxSizing,
      sizingStyle = nodeSizingProps.sizingStyle;
  Object.keys(sizingStyle).forEach(function (key) {
    hiddenTextarea.style.setProperty(key, sizingStyle[key]);
  });
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    hiddenTextarea.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
  hiddenTextarea.value = node.value || node.placeholder || '';
  var minHeight = 0;
  var maxHeight = Number.MAX_SAFE_INTEGER;
  var rawHeight = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    rawHeight += borderSize;
  } else if (boxSizing === 'content-box') {
    rawHeight -= paddingSize;
  }

  var height = rawHeight;

  if (minRows !== null || maxRows !== null) {
    hiddenTextarea.value = '';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;

      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }

      height = Math.max(minHeight, height);
    }

    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;

      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }

      height = Math.min(maxHeight, height);
    }
  }

  return {
    rawHeight: rawHeight,
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight
  };
};

var _default = computeTextareaHeights;
exports.default = _default;